"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flatToNestedJson = void 0;
const error_1 = require("../error");
// converts a flat inputJSON to nested JSON structure.
// for example inputJSON:
// { "a#b#c": 24, "a#b#d": 25, "a#e": 26 }
//
// will be converted to
// {
//   a: {
//     b: {
//       c: 24,
//       d: 25
//     },
//     e: 26
//   }
// }
const flatToNestedJson = ({ inputJSON, separator = '#', }) => {
    const resultJSON = {};
    Object.keys(inputJSON).forEach((field) => {
        const nestedKeys = field.split(separator);
        let current = resultJSON;
        nestedKeys.forEach((key, index) => {
            if (index === nestedKeys.length - 1) {
                (0, error_1.finleyAssert)(!(key in current), `Duplicate field encountered @ ${key} for ${field}`);
                current[key] = inputJSON[field];
            }
            else {
                if (key in current) {
                    (0, error_1.finleyAssert)(typeof current[key] === 'object' && current[key] !== null, `Duplicate field encountered @ ${key} for ${field}`);
                }
                else {
                    current[key] = {};
                }
                current = current[key];
            }
        });
    });
    return resultJSON;
};
exports.flatToNestedJson = flatToNestedJson;
//# sourceMappingURL=flatToNestedJson.js.map